import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { createPopper, Instance } from '@popperjs/core';

@Component({
  selector: 'lib-viewing-rows-dropdown',
  imports: [MatIcon],
  templateUrl: './viewing-rows-dropdown.component.html',
  styleUrl: './viewing-rows-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewingRowsDropdownComponent {
  viewingRowCount = output<number>();

  dropdownContent = viewChild<ElementRef<HTMLDivElement>>('dropdownContent');
  dropdownInput = viewChild<ElementRef<HTMLDivElement>>('dropdownInput');

  pageSizeOptions = input.required<number[]>();

  showDropdown = signal(false);
  selectedRowCount = signal(10);

  protected readonly focus = focus;
  private popperInstance: Instance | undefined;

  constructor() {
    effect(() => {
      this.viewingRowCount.emit(this.selectedRowCount());
    });
  }

  public toggleDropdown() {
    this.showDropdown.update(s => !s);

    if (this.showDropdown()) {
      this.positionDropdown();
    }
  }

  public closeDropdown(): void {
    setTimeout(() => {
      // This is a hack:
      // This setTimeout prevents a second dropdown input position from being incorrect
      this.showDropdown.set(false);
      this.popperInstance?.destroy();
    });
  }

  public optionSelected(optionValue: number) {
    this.selectedRowCount.set(optionValue);
    this.closeDropdown();
  }

  private positionDropdown(): void {
    const dropdownContent = this.dropdownContent();
    const dropdownInput = this.dropdownInput();
    if (!dropdownContent || !dropdownInput) return;
    const dropdownElement = dropdownContent.nativeElement;
    this.popperInstance = createPopper(dropdownInput.nativeElement, dropdownElement, {
      placement: 'bottom-start',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
        {
          name: 'eventListeners',
          enabled: true,
          options: {
            scroll: true,
          },
        },
        {
          name: 'flip',
          options: {
            altBoundary: true,
            padding: { bottom: 24 },
          },
        },
      ],
      strategy: 'fixed',
    });
  }
}
